{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "changelog_record_schema.json",
  "title": "ChangelogRecord",
  "description": "Canonical schema for changelog records - aggregates N tasks into 1 release note",
  "additionalProperties": false,
  "type": "object",
  "required": [
    "id",
    "title",
    "description",
    "relatedTasks",
    "completedAt"
  ],
  "properties": {
    "id": {
      "type": "string",
      "pattern": "^\\d{10}-changelog-[a-z0-9-]{1,50}$",
      "maxLength": 71,
      "description": "Unique identifier for the changelog entry",
      "examples": [
        "1752707800-changelog-sistema-autenticacion-v1",
        "1752707800-changelog-sprint-24-api-performance"
      ]
    },
    "title": {
      "type": "string",
      "minLength": 10,
      "maxLength": 150,
      "description": "Executive title of the deliverable",
      "examples": [
        "Sistema de Autenticación Completo v1.0",
        "Sprint 24 - Performance Optimizations"
      ]
    },
    "description": {
      "type": "string",
      "minLength": 20,
      "maxLength": 5000,
      "description": "Detailed description of the value delivered, including key decisions and impact"
    },
    "relatedTasks": {
      "type": "array",
      "items": {
        "type": "string",
        "pattern": "^\\d{10}-task-[a-z0-9-]{1,50}$"
      },
      "minItems": 1,
      "description": "IDs of tasks that compose this deliverable (minimum 1 required)"
    },
    "completedAt": {
      "type": "number",
      "minimum": 0,
      "description": "Unix timestamp in seconds when the deliverable was completed"
    },
    "relatedCycles": {
      "type": "array",
      "items": {
        "type": "string",
        "pattern": "^\\d{10}-cycle-[a-z0-9-]{1,50}$"
      },
      "default": [],
      "description": "Optional IDs of cycles related to this deliverable"
    },
    "relatedExecutions": {
      "type": "array",
      "items": {
        "type": "string",
        "pattern": "^\\d{10}-exec-[a-z0-9-]{1,50}$"
      },
      "default": [],
      "description": "Optional IDs of key execution records related to this work"
    },
    "version": {
      "type": "string",
      "minLength": 1,
      "maxLength": 50,
      "description": "Optional version or release identifier (e.g., 'v1.0.0', 'sprint-24')",
      "examples": [
        "v1.0.0",
        "v2.1.3",
        "sprint-24"
      ]
    },
    "tags": {
      "type": "array",
      "items": {
        "type": "string",
        "pattern": "^[a-z0-9-]+(:[a-z0-9-]+)*$"
      },
      "default": [],
      "description": "Optional tags for categorization (e.g., 'feature:auth', 'bugfix', 'security')"
    },
    "commits": {
      "type": "array",
      "items": {
        "type": "string",
        "maxLength": 100
      },
      "default": [],
      "description": "Optional list of git commit hashes related to this deliverable"
    },
    "files": {
      "type": "array",
      "items": {
        "type": "string",
        "maxLength": 500
      },
      "default": [],
      "description": "Optional list of main files that were created or modified"
    },
    "notes": {
      "type": "string",
      "maxLength": 3000,
      "description": "Optional additional context, decisions, or learnings"
    }
  },
  "examples": [
    {
      "id": "1752707800-changelog-sistema-autenticacion-v1",
      "title": "Sistema de Autenticación Completo v1.0",
      "description": "Implementación completa del sistema de autenticación con OAuth2, 2FA via TOTP, recuperación de contraseña, y UI responsive. Incluye tests E2E completos (95% coverage) y documentación técnica actualizada.",
      "relatedTasks": [
        "1752274500-task-crear-ui-login",
        "1752274600-task-integrar-oauth2-backend",
        "1752274700-task-implementar-2fa-totp",
        "1752274800-task-tests-e2e-auth",
        "1752274900-task-documentar-flujo-auth"
      ],
      "completedAt": 1752707800,
      "relatedCycles": [
        "1752200000-cycle-q1-auth-milestone"
      ],
      "relatedExecutions": [
        "1752274550-exec-analisis-auth-providers",
        "1752707750-exec-final-integration-test"
      ],
      "version": "v1.0.0",
      "tags": [
        "feature:auth",
        "security",
        "frontend",
        "backend"
      ],
      "commits": [
        "abc123def",
        "456ghi789",
        "jkl012mno"
      ],
      "files": [
        "src/pages/Login.tsx",
        "src/services/auth.ts",
        "src/components/TwoFactorSetup.tsx",
        "e2e/auth.spec.ts"
      ],
      "notes": "Decisión técnica: Usamos NextAuth.js después de evaluar Passport.js. El 2FA se implementó con TOTP (Google Authenticator compatible) en lugar de SMS por seguridad y costo."
    },
    {
      "id": "1752707900-changelog-hotfix-payment-timeout",
      "title": "Hotfix: Critical Payment Timeout Fix",
      "description": "Fixed critical payment timeout issue affecting 15% of transactions. Increased timeout from 5s to 30s and added circuit breaker pattern for third-party API calls.",
      "relatedTasks": [
        "1752707850-task-fix-payment-timeout",
        "1752707870-task-add-circuit-breaker"
      ],
      "completedAt": 1752707900,
      "version": "v1.2.1",
      "tags": [
        "hotfix",
        "critical",
        "payment"
      ],
      "commits": [
        "xyz789abc"
      ],
      "notes": "Emergency response to production incident. Deployed to production within 2 hours."
    }
  ]
}